










































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import TextInput from "@/components/TextInput.vue";
import DropDownInput from "@/components/DropDownInput.vue";
import { userService } from "@/services/user.service";
import { pinboardService } from "@/services/pinboard.service";
import { PinBoard } from "@/models/pinboard.model";
import { User} from "@/models/user.model";
import store from "@/store/store";
import { faUnderline } from '@fortawesome/free-solid-svg-icons';
import { CardModel } from '../../models/card.model';
import { cardService } from '../../services/card.service';
require("@/assets/css/modal.scss");

@Component(
    {
        components : {
            TextInput,
            DropDownInput,
        }
    }
)
export default class UserModal extends Vue{
    @Prop() private id!: number;
    showContent:boolean = false;
    pinboards:any[] = [];
    users:any[] = [];
    selectedPinboard:any = [];
    card:CardModel = {companyId:this.$store.getters["app/companyId"]};
    errors: string[] = [];
    file: any;
    selectedUsers:any[] = [];

    userImageSourceFromBase64:string = "";


    async created(){
        this.pinboards = await pinboardService.getAllKeyValue(this.$store.getters["app/companyId"]);
        this.users = await userService.getAllKeyValue(this.$store.getters["app/companyId"]);
    }

    @Watch("selectedUsers")
    selectedUserChanged(){
    }

    async save(){
        store.dispatch("app/resetErrors");
        this.card.cardUserIds = this.selectedUsers.map(u => u.key);
        this.card.pinBoardIds = this.selectedPinboard;
        this.card.companyId = this.$store.getters["app/companyId"];
        cardService.create(this.card).then((response) => {
            this.card.id = response.data;

            if(this.file && !this.card.image){
                this.createImage();
            }
            this.$notify({
                group: 'message',
                title: 'Succe!',
                text: 'Användare skapad',
                duration: 5000,
                type: 'success',
            });

            this.$emit("modalEmit", 'saved', this.card.id);
        });
    }


    async createImage(){
            let formData = new FormData();
            formData.append('file', this.file);
            await cardService.createImage(formData, this.card.id!);
            this.newImage = false;
    }

    async updateImage(){
            let formData = new FormData();
            formData.append('file', this.file);
            await cardService.updateImage(formData, this.card.id!);
            this.newImage = false;
    }

    close(){
        this.showContent = false;
        this.$emit("modalEmit", 'close');
    }

    async update(){
        store.dispatch("app/resetErrors");
        this.card.cardUserIds = this.selectedUsers.map(u => u.key);
        this.card.pinBoardIds = this.selectedPinboard;
        this.card.companyId = this.$store.getters["app/companyId"];
        cardService.update(this.card).then((response) => {
            if(this.file){
                if(this.card.image){
                    this.updateImage();
                }
                else{
                    this.createImage();
                }
            }

            this.$notify({
                group: 'message',
                title: 'Succe!',
                text: 'Kort uppdaterad',
                duration: 5000,
                type: 'success',
            });
            this.$emit("modalEmit", 'saved');
        });
    }

    newImage:boolean = false;
    // REGION image upload
    processFile(event:any) {
        this.errors = [];
        this.file = event.target.files[0];
        if(!this.file.name.toLowerCase().includes(".png") 
        && !this.file.name.toLowerCase().includes(".gif") 
        && !this.file.name.toLowerCase().includes(".jpg") 
        && !this.file.name.toLowerCase().includes(".gif")){
            this.errors.push("Endast jpg, gif, png tillåtna");
        }

        this.newImage = true;
        this.userImageSourceFromBase64 = URL.createObjectURL(this.file);
    }

    // ENDREGION image upload

    @Watch('id')
    async idChanged(){
        this.errors = [];
        this.userImageSourceFromBase64 = "";
        if(this.id != 0){
            this.card = await cardService.get(this.id);
            this.selectedPinboard = this.card.pinBoardIds;
            this.selectedUsers =  this.card.cardUserIds!.map(cu => ({key : cu, value:this.users.find(u => u.key == cu).value}));
            // if(this.user.imgBase64 != null){
            //     this.userImageSourceFromBase64 = "data:image/png;base64," + this.user.imgBase64;
            // }
        }
        else{
            this.card = {};
            this.userImageSourceFromBase64 = "";
            this.selectedPinboard = [];
            this.selectedUsers = [];
        }
    }
}
